import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import Row from 'react-bootstrap/Row';
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Table from 'react-bootstrap/Table';
import Button from "react-bootstrap/Button";
import { Container } from "react-bootstrap";
// ************** Datatable
import 'datatables.net-dt/css/dataTables.dataTables.css';  // Estilos de DataTable
import 'datatables.net';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Modal from 'react-bootstrap/Modal';

const UsuariosForm = ({usuario, apiUrl}) => {
    // ****** Definiciones de variables
    const dateFechaActual = new Date();
    dateFechaActual.setHours(0, 0, 0, 0);
    // Variables de selección
    const [idUsuarioSelected, setIdUsuarioSelected] = useState(-1);
    const [loginSelected, setLoginSelected] = useState('');
    const [passwordSelected, setPasswordSelected] = useState('');
    const [usuarioSelected, setUsuarioSelected] = useState('');
    const [emailSelected, setEmailSelected] = useState('');
    const [idPersonaSelected, setIdPersonaSelected] = useState(0);
    const [idPerfilSelected, setIdPerfilSelected] = useState(0);
    const [perfilSelected, setPerfilSelected] = useState(0);
    const [activoSelected, setActivoSelected] = useState(0);
    const [modificacion, setModificacion] = useState(0);
    // Variables para mostrar modales
    const [showModal, setShowModal] = useState(false);
    const [showModalDetalle, setShowModalDetalle] = useState(false);
    const [showModalPassword, setShowModalPassword] = useState(false);
    // Variables para listado
    const [usuarios, setUsuarios] = useState([]);
    const [personas, setPersonas] = useState([]);
    const [perfiles, setPerfiles] = useState([]);
    
    // ******** Definición de funciones
    // Funciones para los modales
    const handleShowModalDetalle = (IDUSUARIO, LOGIN, USUARIO, PERFIL, IDPERSONA, Activo, EMAIL) => {
        setIdUsuarioSelected(IDUSUARIO)
        setLoginSelected(LOGIN)
        setUsuarioSelected(USUARIO)
        setPerfilSelected(PERFIL)
        setIdPersonaSelected(IDPERSONA)
        setActivoSelected(Activo)
        setEmailSelected(EMAIL)
        //
        setShowModalDetalle(true);
    }
    const handleCloseModalDetalle = () => {
        limpiarVariables();
        setShowModalDetalle(false);
    }
    
    const handleShowModal = (IDUSUARIO, LOGIN, NOMBREUSUARIO, IDPERSONA, IDPERFIL, EMAIL, MODIFICA) => {
        console.log("MODIFICA")
        console.log(MODIFICA)
        setIdUsuarioSelected(IDUSUARIO)
        setLoginSelected(LOGIN)
        setUsuarioSelected(NOMBREUSUARIO)
        setIdPersonaSelected(IDPERSONA)
        setIdPerfilSelected(IDPERFIL)
        setEmailSelected(EMAIL)
        //
        setModificacion(MODIFICA)
        setShowModal(true);
    }
    const handleCloseModal = () => {
        limpiarVariables();
        setShowModal(false);
    }
    //
    const handleShowModalPassword = (IDUSUARIO) => {
        setIdUsuarioSelected(IDUSUARIO);
        setShowModalPassword(true);
    }
    const handleCloseModalPassword = () => {
        //limpiarVariables();
        setShowModalPassword(false);
    }

    const limpiarVariables = () => {
        setIdUsuarioSelected(0);
        setLoginSelected('');
        setPasswordSelected('');
        setUsuarioSelected('');
        setEmailSelected('');
        setIdPersonaSelected(0);
        setIdPerfilSelected(0);
    }

    // Funciones para traer datos
    const obtenerUsuarios = () => {
        axios.post(`${apiUrl}/usuario/obtenTodosUsuarios?token=${sessionStorage.getItem('token')}`, {})
            .then((objResponse)=>{
                setUsuarios(objResponse.data.response);
            })
            .catch((error)=>{
                alert('hubo un error en la obtención de personas: ' + error.response.data)
            })
    }

    const obtenerPersonas = () => {
        axios.post(`${apiUrl}/usuario/obtenPersonas?token=${sessionStorage.getItem('token')}`, {})
            .then((objResponse)=>{
                setPersonas(objResponse.data.response.personas);
            })
            .catch((error)=>{
                alert('hubo un error en la obtención de personas: ' + error.response.data)
            })
    }

    const obtenerPerfiles = () => {
        axios.post(`${apiUrl}/perfil/obtenPerfiles?token=${sessionStorage.getItem('token')}`, {})
            .then((objResponse)=>{
                setPerfiles(objResponse.data.response);
            })
            .catch((error)=>{
                alert('hubo un error en la obtención de perfiles: ' + error.response.data)
            })
    }
    //
    useEffect(()=>{
        obtenerUsuarios();
        obtenerPersonas();
        obtenerPerfiles();
    }, [])

    // Funciones para guardar información
    const actualizarEstatusUsuario = (paramIDUSUARIO, paramEstatus) => {
        axios.post(`${apiUrl}/usuario/actualizarEstatusUsuario?token=${sessionStorage.getItem('token')}`, 
            {
                IDUSUARIO: paramIDUSUARIO,
                nuevoEstado: paramEstatus,
                USUARIOMODIFICACION: usuario.IDUSUARIO
            })
            .then((objResponse)=>{
                obtenerUsuarios();
            })
            .catch((error)=>{
                alert('hubo un error en la actualización de estado de usuario: ' + error.response.data)
            })
    }

    const guardarUsuario = () => {
        axios.post(`${apiUrl}/usuario/guardarUsuario?token=${sessionStorage.getItem('token')}`, 
            {
                IDUSUARIO: idUsuarioSelected,
                LOGIN: loginSelected,
                PASSWORD: passwordSelected,
                NOMBREUSUARIO: usuarioSelected,
                EMAIL: emailSelected,
                IDPERSONA: idPersonaSelected,
                IDPERFIL: idPerfilSelected,
                IDUSUARIOMODIFICACION: usuario.IDUSUARIO,
                MODIFICACION: modificacion
            })
            .then((objResponse)=>{
                if(objResponse.data.usuario.idUsuario === 0) {
                    alert(`Ya existe el usuario ${loginSelected} con la persona `);
                    return;
                }
                obtenerUsuarios();
                handleCloseModal();
            })
            .catch((error)=>{
                alert('hubo un error en la actualización del usuario: ' + error.response.data)
            })
        //*/
    }

    const resetPassword = () => {
        axios.post(`${apiUrl}/usuario/resetPassword?token=${sessionStorage.getItem('token')}`, 
            {
                IDUSUARIO: idUsuarioSelected,
                PASSWORD: passwordSelected,
                USUARIOMODIFICACION: usuario.IDUSUARIO
            })
            .then((objResponse)=>{
                obtenerUsuarios();
                handleCloseModalPassword();
                setPasswordSelected("");
            })
            .catch((error)=>{
                alert('hubo un error en la actualización del usuario: ' + error.response.data)
            })
    }

    const columns = [
        { data: 'IDUSUARIO', with: "5%"},
        { data: 'LOGIN', with: "10%"},
        { data: 'NOMBREUSUARIO' },
        { data: 'EMAIL', visible: false},
        { data: 'IDPERFIL', with: "10%", visible: false},
        { data: 'PERFIL', with: "10%"},
        { data: 'Activo', visible: false},
        { data: 'IDPERSONA', visible: false}, //
        { title: 'Opciones', with: "10%"},
    ];

    const languageOpt = {
        info: 'Mostrando página _PAGE_ de _PAGES_ (total de _MAX_ encontrados)',
        infoFiltered: '(filtrados de un total de _MAX_ encontrados)',
        lengthMenu: 'Mostrando _MENU_ registros por página',
        zeroRecords: 'Cero colaboradores encontrados con los filtros seleccionados',
        search: 'Buscar',
        infoEmpty: 'No se encontraron',
        emptyTable: 'Tabla vacía (sin registros)'
    }
    
    const options = {
        order: [[0, 'desc']], // Indica que la primera columna (índice 0) se ordene de manera descendente
        columnsDefs: [
            {
                //targets: 1, // Índice de la columna a la que le queremos dar ancho
                //width: '100%' // El ancho deseado para esa columna
            },
            {
                //targets: [9],
                //width: '100px',
            }
        ],
        language: languageOpt,
        responsive: true
    };

    return(
        <div>
            {/* 
                Modal para detalle de usuario
            */}
            <Modal show={showModalDetalle} onHide={handleCloseModalDetalle} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Detalle usuario
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table striped hover responsive size="sm" style={{fontSize: '1em'}}>
                        <tbody>
                            <tr>
                                <td width="50%">idUsuario</td>
                                <td width="50%">{idUsuarioSelected}</td>
                            </tr>
                            <tr>
                                <td>Login</td>
                                <td>{loginSelected}</td>
                            </tr>
                            <tr>
                                <td>Nombre Usuario</td>
                                <td>{usuarioSelected}</td>
                            </tr>
                            <tr>
                                <td>Email</td>
                                <td>{emailSelected}</td>
                            </tr>
                            <tr>
                                <td>idPersona</td>
                                <td>{idPersonaSelected}</td>
                            </tr>
                            <tr>
                                <td>Perfil</td>
                                <td>{perfilSelected}</td>
                            </tr>
                            <tr>
                                <td>Estado usuario</td>
                                <td>
                                    {
                                        (activoSelected) ? 'Activo' : 'Inactivado'
                                    }
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModalDetalle}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* 
                Modal para crear/actualizar de usuario
            */}
            <Modal show={showModal} onHide={handleCloseModal} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Guardar usuario
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table striped hover responsive>
                        <tbody>
                            <tr>
                                <td width="50%">idUsuario</td>
                                <td width="50%">{idUsuarioSelected}</td>
                            </tr>
                            <tr>
                                <td>Login</td>
                                <td>
                                    <Form.Control value={loginSelected} onChange={(event)=>{ setLoginSelected(event.target.value) }}></Form.Control>
                                </td>
                            </tr>
                            {
                                (idUsuarioSelected===-1) ?
                                    <tr>
                                        <td>Password</td>
                                        <td>
                                            <Form.Control type="password" value={passwordSelected} onChange={(event)=>{ setPasswordSelected(event.target.value) }}></Form.Control>
                                        </td>
                                    </tr>
                                : ''
                            }
                            <tr>
                                <td>Nombre usuario</td>
                                <td>
                                    <Form.Control value={usuarioSelected} onChange={(event)=>{ setUsuarioSelected(event.target.value) }}></Form.Control>
                                </td>
                            </tr>
                            <tr>
                                <td>Email</td>
                                <td>
                                    <Form.Control value={emailSelected} onChange={(event)=>{ setEmailSelected(event.target.value) }}></Form.Control>
                                </td>
                            </tr>
                            
                            <tr>
                                <td>idPersona</td>
                                <td>
                                    <Form.Select
                                        value={idPersonaSelected}
                                        onChange={(event)=>{
                                            setIdPersonaSelected(event.target.value)
                                        }}
                                    >
                                        <option key="" value={0}>--- Escoge una persona ---</option>
                                        {
                                            personas.map(persona=>
                                                <option 
                                                    key={'opt_persona'+persona.IDPERSONA} 
                                                    value={persona.IDPERSONA}
                                                >
                                                    {persona.NOMBRE} [{persona.PUESTO}]
                                                </option>
                                            )
                                        }
                                    </Form.Select>
                                </td>
                            </tr>
                            <tr>
                                <td>Perfil</td>
                                <td>
                                    <Form.Select
                                        value={idPerfilSelected}
                                        onChange={(event)=>{
                                            setIdPerfilSelected(event.target.value)
                                        }}
                                    >
                                        <option key="" value={0}>--- Escoge un perfil ---</option>
                                        {
                                            perfiles.map(perfil=>
                                                <option 
                                                    key={'opt_perfil'+perfil.idPerfil}
                                                    value={perfil.idPerfil}
                                                >
                                                    {perfil.perfilDes}
                                                </option>
                                            )
                                        }
                                    </Form.Select>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Close
                    </Button>
                    <Button 
                        variant="success" 
                        onClick={guardarUsuario}
                    >
                        Guardar usuario
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* 
                Modal para actualizar password de usuario
            */}
            <Modal show={showModalPassword} onHide={handleCloseModalPassword} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Actualizar contraseña usuario
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table striped hover responsive size="sm" style={{fontSize: '1em'}}>
                        <tbody>
                            <tr>
                                <td>Contraseña temporal</td>
                                <td>
                                    <Form.Control type="password" value={passwordSelected} onChange={(event)=>{ setPasswordSelected(event.target.value) }}></Form.Control>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModalPassword}>
                        Close
                    </Button>
                    <Button 
                        variant="success" 
                        onClick={resetPassword}
                    >
                        Reset
                    </Button>
                </Modal.Footer>
            </Modal>
            {/*  
                Contenido principal
            */}
            <h3 style={{textAlign: 'center'}}>ADMINISTRACIÓN DE USUARIOS</h3>
            <Container>
                <Row style={{paddingTop: '1em', alignItems: 'right'}} className="justify-content-md-center">
                    <Col>
                        Agregar usuario <i onClick={()=>{
                            handleShowModal(-1, '', '', 0, 0, '', 0)
                        }} className="btn btn-success btn-sm bi bi-person-fill-add"></i>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <DataTable
                            columns={columns} 
                            data={usuarios}  
                            className="display"
                            options={options}
                            responsive={true}
                            slots={{
                                8: (data, row) => (
                                    <div>
                                        {/* 
                                            **** Ver detalle usuario
                                        */}
                                        <OverlayTrigger
                                            placement='top'
                                            overlay={
                                                <Tooltip>
                                                    <strong>Ver detalle </strong> usuario.
                                                </Tooltip>
                                            }
                                        >
                                            
                                            <Button 
                                                className="btn-default btn-sm bi bi-search"
                                                style={{marginRight: '1em'}}
                                                onClick={
                                                    () => {
                                                        handleShowModalDetalle(row.IDUSUARIO, row.LOGIN, row.NOMBREUSUARIO, row.PERFIL, row.IDPERSONA, row.Activo, row.EMAIL)
                                                    }
                                                }
                                            >
                                            </Button>
                                        </OverlayTrigger>
                                        {/* 
                                            **** Editar usuario
                                        */}
                                        <OverlayTrigger
                                            placement='top'
                                            overlay={
                                                <Tooltip>
                                                    <strong>Editar </strong> usuario.
                                                </Tooltip>
                                            }
                                        >
                                            <Button 
                                                className="btn-warning btn-sm bi bi-pencil-square"
                                                style={{marginRight: '1em'}}
                                                onClick={
                                                    () => {
                                                        handleShowModal(row.IDUSUARIO, row.LOGIN, row.NOMBREUSUARIO, row.IDPERSONA, row.IDPERFIL, row.EMAIL, 1)
                                                    }
                                                }
                                            >
                                            </Button>
                                        </OverlayTrigger>
                                        {/* 
                                            **** Actualizar password usuario
                                        */}
                                        <OverlayTrigger
                                            placement='top'
                                            overlay={
                                                <Tooltip>
                                                    <strong>Reset password </strong> usuario.
                                                </Tooltip>
                                            }
                                        >
                                            <Button 
                                                className="btn-secondary btn-sm bi bi-key-fill"
                                                style={{marginRight: '1em'}}
                                                onClick={
                                                    () => {
                                                        handleShowModalPassword(row.IDUSUARIO)
                                                    }
                                                }
                                            >
                                            </Button>
                                        </OverlayTrigger>
                                        {/* 
                                            **** activar/inactivar usuario
                                        */}
                                        <Form.Check 
                                            type="switch"
                                            id="custom-switch"
                                            defaultChecked={row.Activo}
                                            onChange={(event)=>{
                                                actualizarEstatusUsuario(row.IDUSUARIO, event.target.checked)
                                            }}
                                        />
                                    </div>
                                )
                            }}
                        >
                            <thead>
                                <tr>
                                    <th className="dt-orderable-asc">IDUSUARIO</th>
                                    <th>LOGIN</th>
                                    <th>USUARIO</th>
                                    <th>IDPERFIL</th>
                                    <th>PERFIL</th>
                                    <th>IDPERSONA</th>
                                </tr>
                            </thead>
                        </DataTable>
                    </Col>
                </Row>    
            </Container>
        </div>
    )
}

export default UsuariosForm;